import type { LegendSwatchProps } from "./types-legend-swatch";
import { LegendSwatchView } from "./view-legend-swatch";

export function LegendSwatch(props: LegendSwatchProps) {
  return <LegendSwatchView {...props} />;
}

export type * from "./types-legend-swatch";
